<template>
    <div id="app">
        <!--路由展示 -->
        <!-- 路由渲染位置 出口地址 -->
<!--        缓存页面数据-->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" class="router-view">
            </router-view>
        </keep-alive>
<!--        不缓存 -->
        <router-view v-if="!$route.meta.keepAlive" class="router-view" ></router-view>
        <!-- 底部导航 已经变成了组件 在此引入 直接写组件名-->
<!--        <NavButton />-->
    </div>
</template>

<script>
    // 引入NavButton底部导航组件
    // import NavButton from '../../components/NavButton';
    export default {
        name: "appHome",
        // 添加底部导航组件 写组件名就行 多个组件用逗号,分隔开
        // components:{
        //     NavButton
        // },
    }
</script>

<style scoped>
    @import '../../assets/css/index.css';
</style>